import screenfull from 'screenfull';
import config from '../config';

const GameFrameBackend = {
  on: {
    getGameFrame(callback: Function) {
      const dalay = setTimeout(() => {
        const frames = document.getElementsByTagName('iframe');
        const gf = Array.from(frames).find((item: HTMLIFrameElement) =>
          item.src.includes(config.launcher.apiUrl)
        );
        callback(gf ? gf.contentWindow : null);
      }, 0);
      return () => {
        clearTimeout(dalay);
      };
    },
    onMessage(callback: Function) {
      const listener = (event: MessageEvent) => {
        const apiUrl = new URL(config.launcher.apiUrl);
        if (event.origin.includes(apiUrl.origin)) {
          callback(event.data);
        }
      };
      window.addEventListener('message', listener);
      return () => {
        window.removeEventListener('message', listener);
      };
    },
  },
  invoke: {
    postMessageToGameFrame([topic, data]: [string, any]) {
      const frames = document.getElementsByTagName('iframe');
      const gameFrame = Array.from(frames).find((item: HTMLIFrameElement) =>
        item.src.includes(config.launcher.apiUrl)
      );
      gameFrame?.contentWindow?.postMessage({ message: { topic, data } }, '*');
    },
    exitFullscreen() {
      if (screenfull.isEnabled) {
        screenfull.exit();
      }
    },
  },
};

export default GameFrameBackend;
